module.exports = __webpack_public_path__ + "static/media/ste_2007_1.cfa06a83.jpg";